export const MAX_IMPRESSIONS_COUNT = 60
